import { ActionReducerMap } from '@ngrx/store';
import { businessUserReducer } from './businessUser/businessUser.reducer';
export interface AppState {
  businessUser: ReturnType<typeof businessUserReducer>;
}

export const reducers: ActionReducerMap<AppState> = {
  businessUser: businessUserReducer,
};
